import {
  DTODesignSystemMemberListResponse,
  DTODesignSystemMembersUpdatePayload,
  DTODesignSystemMembersUpdateResponse,
  DTOUserGetResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class DesignSystemMembersEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(dsId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/members`, DTODesignSystemMemberListResponse, {
      method: "GET",
    });
  }

  update(dsId: string, body: DTODesignSystemMembersUpdatePayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/members`, DTODesignSystemMembersUpdateResponse, {
      method: "POST",
      body,
    });
  }
}
